import { ObjectFitProperty } from "csstype";
import React from "react";

import { ITabProps, Tab, Tabs } from "@blueprintjs/core";
import autobind from "autobind-decorator";
import { IViewProps, View } from "core/decorators/View";
import { iDef } from "core/util/TypeUtils";
import styled, { css } from "styled-components";
import TabsViewConfig from "./TabsViewConfig";

/*
const TabNav = styled.ul`
    margin-bottom: 20px;
	display: flex;
 `;

const TabLink = styled.li<{active: boolean}>`
	padding: 5px 15px 15px 15px;
	font-size: 18px;
	font-weight: bold;
	flex: 0;
	white-space: nowrap;
	text-overflow: ellipsis;

	${({active}) => active ? `
		border-bottom: 5px solid #00aeef;
		color: #575757;

		& > a {
			color: #575757;
		}
	` : `
		border-bottom: 2px solid #8b8b8b;
		color: #0b76c8;

		& > a {
			color: #0b76c8;
		}
	`}

	&:first-child {
		padding-left: 5px;
	}
`;

const TabSpacer = styled.li`
	flex: 2;
	border-bottom: 2px solid #8b8b8b;
	color: blue;
`;
*/

interface ITabNavProps extends ITabProps {
	config: TabsViewConfig;
}

const TabNav = styled(Tabs)<ITabNavProps>(({config}) => {

	return css`
		& .bp3-tab[aria-selected="true"],
		& .bp3-tab:not([aria-disabled="true"]):hover {
			color: ${config.color};
		}

		&.bp3-tabs.bp3-vertical > .bp3-tab-list .bp3-tab-indicator-wrapper .bp3-tab-indicator {
			background-color: ${config.color};
			opacity: 0.14;
		}

		& .bp3-tab-indicator-wrapper .bp3-tab-indicator {
			background-color: ${config.color};
		}

		& .tab-content {
			padding: ${config.contentPadding || "15px"};
		}
	`;
});

export interface ITab<T = (string | JSX.Element)> {
	key: React.Key;
	label: T;
	content: T;
}

interface ITabsViewProps extends IViewProps<TabsViewConfig> {
	tabs: ITab[];
	vertical?: boolean;
}


@View({id: "tabs", configClass: TabsViewConfig})
export class TabsView extends React.Component<ITabsViewProps> {

	public render() {

		const { config, tabs } = this.props;

		if (!tabs || tabs.length < 1) {
			return null;
		}

		if (tabs.length === 1) {
			return tabs[0].content || null;
		}

		return (
			<TabNav id={this.props.panelInstance + ":" + this.props.viewKey} config={config} large={config.large} vertical={config.vertical}>
				{
					tabs.map((tab) => {

						return (
							<Tab
								key={tab.key}
								id={tab.key}
								title={tab.label}
								panel={
									<div className="tab-content">
										{tab.content}
									</div>
								}
							/>
						);
					})
				}
			</TabNav>
		);
	}
}





// WEBPACK FOOTER //
// ./src/common/views/tab/Tabs.view.tsx